"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredMessage = void 0;
const i18n_1 = require("../i18n");
const mithril_1 = require("../mithril");
const theme_1 = require("./theme");
const CSS = {
    container: 'c-CenteredMessage'
};
const Style = {
    [CSS.container]: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
    }
};
(0, theme_1.addStyles)(Style);
exports.CenteredMessage = {
    view(message) {
        return (0, mithril_1.m)('div', { className: CSS.container }, (0, i18n_1.Translate)(message));
    }
};
//# sourceMappingURL=centeredMessage.js.map